import { StorageHelper } from '../utils/storageHelper';

export class BaseApiClient {
  /**
   * Transforms request options before they're sent, primarily adding auth tokens
   */
  protected transformOptions(options: RequestInit): Promise<RequestInit> {
    // Add authorization header with JWT token if available
    const token = StorageHelper.getToken();
    if (token) {
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${token}`
      };
    }
    
    return Promise.resolve(options);
  }

  /**
   * Standard method to handle response transformation
   * Used by generated NSwag clients
   */
  protected transformResult(url: string, response: Response, process: (response: Response) => Promise<any>): Promise<any> {
    return process(response);
  }
}